import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import { cohortUrl } from '@/constants/urls';
import cohortSharingActions from '../constants';

export function* closeTab({ destroy, code }) {
  if (destroy) {
    yield call(listener.closeTab, [cohortUrl({ code })]);
  }
}

export default function* cohortSharingLayout() {
  yield takeEvery(cohortSharingActions.SHARE_COHORT_SUCCESS, closeTab);
}
